export const colors = {
  background: '#0F172A',
  surface: '#1E293B',
  surfaceLight: '#334155',

  work: '#EF4444',
  rest: '#22C55E',
  countdown: '#F59E0B',
  accent: '#38BDF8',

  textPrimary: '#FFFFFF',
  textSecondary: '#CBD5E1',
};

export const phaseColor = (type) => {
  switch (type) {
    case 'work':
      return colors.work;
    case 'rest':
    case 'restBlock':
      return colors.rest;
    case 'countdown':
    case 'warmup':
      return colors.countdown;
    case 'cooldown':
      return colors.accent;
    default:
      return colors.accent;
  }
};

export const phaseGradient = (type) => {
  switch (type) {
    case 'work':
      return 'radial-gradient(120% 120% at 50% 0%, #7F1D1D 0%, #EF4444 45%, #0F172A 100%)';
    case 'rest':
    case 'restBlock':
      return 'radial-gradient(120% 120% at 50% 0%, #14532D 0%, #22C55E 45%, #0F172A 100%)';
    case 'countdown':
    case 'warmup':
      return 'radial-gradient(120% 120% at 50% 0%, #78350F 0%, #F59E0B 45%, #0F172A 100%)';
    case 'cooldown':
      return 'radial-gradient(120% 120% at 50% 0%, #0C4A6E 0%, #38BDF8 45%, #0F172A 100%)';
    default:
      return 'radial-gradient(120% 120% at 50% 0%, #1E293B 0%, #0F172A 100%)';
  }
};
